import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=5d2f0b62&"
import script from "./Audience.vue?vue&type=script&lang=ts&"
export * from "./Audience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports